<template>
  <div :class="['el-textarea', disabled?'is-disabled':'']">
    <div :class="[innerClass, 'el-textarea__inner']"
         :placeholder="placeholder"
         :contenteditable="!disabled"
         v-html="html"
         @input="input"></div>
  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  components: {},
  props: {
    value: String,
    placeholder: String,
    innerClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      html: this.value,
      inputHtml: '',
    }
  },
  computed: {},
  watch: {
    value () {
      if (this.value !== this.inputHtml) {
        this.html = this.value
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    input ($event) {
      this.inputHtml = $event.target.innerHTML
      this.$emit('input', this.inputHtml)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.el-textarea {
  min-height: 66px;
}
.el-textarea__inner {
  min-height: inherit;
  resize: none;

  &[contenteditable=true]:empty:before{
    color: #c7cbd1;
    content: attr(placeholder);
    display: block; /* For Firefox */
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/InputHtml.vue